import React from 'react';
import { number, string, object, oneOfType } from 'prop-types';
import DateTime from '../DateTime/DateTime';

const propTypes = {
  created_ts: number.isRequired,
  approved_ts: number.isRequired,
  stream_id: number.isRequired,
  offer_id: number.isRequired,
  hold_expire: number.isRequired,
  currency: string.isRequired,
  sum: oneOfType([string, number]).isRequired,
  flow: object,
  offer: object,
};

const PaymentHoldDetailsListItem = ({
  created_ts,
  approved_ts,
  stream_id,
  offer_id,
  hold_expire,
  currency,
  sum,
  flow,
  offer,
  tableSettings
}) => {

  return tableSettings ? (
    <tr>
      {tableSettings.created && <td>
        <DateTime timestamp={created_ts} />
      </td>}

      {tableSettings.accepted && <td>
        <DateTime timestamp={approved_ts} />
      </td>}

      {tableSettings.flow && <td>{flow ? flow.title : stream_id}</td>}
      {tableSettings.offer && <td>{offer ? offer.title : offer_id}</td>}
      {tableSettings.transfer && <td>
        <DateTime timestamp={hold_expire} />
      </td>}
      {tableSettings.amount && <td className="text-right">
        {sum}
        &nbsp;
        {currency}
      </td>}
    </tr>
  )
    :
    (
      <tr>
        <td>
          <DateTime timestamp={created_ts} />
        </td>

        <td>
          <DateTime timestamp={approved_ts} />
        </td>

        <td>{flow ? flow.title : stream_id}</td>
        <td>{offer ? offer.title : offer_id}</td>
        <td>
          <DateTime timestamp={hold_expire} />
        </td>
        <td className="text-right">
          {sum}
          &nbsp;
        {currency}
        </td>
      </tr>
    )

};

PaymentHoldDetailsListItem.propTypes = propTypes;

export default PaymentHoldDetailsListItem;
